import { render, staticRenderFns } from "./DatosCentro.vue?vue&type=template&id=9cadca52&"
import script from "./DatosCentro.vue?vue&type=script&lang=js&"
export * from "./DatosCentro.vue?vue&type=script&lang=js&"
import style0 from "./DatosCentro.vue?vue&type=style&index=0&id=9cadca52&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports